<template>
  <zingchart :data="chartConfig" :width="1000" />
</template>

<script>
  export default {
    data() {
      return {
        chartConfig: {
          type: 'mixed',
          title: {
            text: 'График 8 (смешанный)',
            align: 'left',
            marginLeft: '23%'
          },
          legend: {
            adjustLayout: true,
            verticalAlign: 'middle'
          },
          scaleX: {
            labels: ['3', '4', '7', '8', '9', '10', '11', '12'] // one label for every datapoint
          },
          series: [{
            type: 'line',
            text: 'Сумма по полю ЦЕНА_ДЛЯ_ГП_разгр_За_Тонну',
            values: [378220.00, 177565.00, 1617305.00, 1298080.00, 1199610.00, 3311423.00, 3765732.00, 1562425.00],
            lineColor: '#f00',
            marker: {
              type: 'circle',
              backgroundColor: '#f00'
            },
            scales: 'scale-x, scale-y'
          }, {
            type: 'bar',
            'background-color': 'blue',
            text: 'Сумма по полю Масса разгруженная',
            values: [13278.70, 4592.25, 58628.84, 40382.67, 37233.39, 80850.45, 87097.42, 54561.42],
            scales: 'scale-x, scale-y'
          }, {
            type: 'bar',
            'background-color': 'green',
            text: 'Сумма по полю Дистанция, км',
            values: [121048.18, 60999.34, 335371.28, 368870.82, 328795.98, 814558.17, 957675.89, 370012.72],
            scales: 'scale-x, scale-y'
          }, {
            type: 'bar',
            'background-color': 'purple',
            text: 'Сумма по полю Тонна/км',
            values: [3.12, 2.91, 4.82, 3.52, 3.65, 4.07, 3.93, 4.22],
            scales: 'scale-x, scale-y'
          }]
        }
      }
    }
  }
</script>

<style scoped>

</style>